export default {
  nav: {
    title: 'Credentials',
  }
}
